<template>
  <section v-if="awards?.length" class="awards pe-section">
    <h3>
      Awards
      <SectionActions v-show="isPowerEdit" class="actions" section="awards" />
    </h3>
    <section class="list">
      <template :key="award.title" v-for="(award, index) in awards">
        <section v-if="award.title || award.awarder" class="award">
          <ItemActions
            v-show="isPowerEdit"
            class="itemActions"
            :index="index"
            section="awards"
            :uuid="award.uuid"
            :actions="['edit', 'delete']"
          />
          <div class="details">
            <div
              v-editable="isPowerEdit"
              :data-target-path="`resume.awards.${index}.title`"
              class="title"
              v-text="award.title"
            ></div>
            <div v-if="award.date">
              <DateDisplay
                class="date"
                :date="award.date"
                :updatePath="`resume.awards.${index}.date`"
                :isEditable="isPowerEdit"
              />
            </div>
          </div>
          <div class="awarder">
            <div
              v-editable="isPowerEdit"
              :data-target-path="`resume.awards.${index}.awarder`"
              v-text="award.awarder"
            ></div>
          </div>
          <span
            v-word-count
            v-editable="isPowerEdit"
            :data-target-path="`resume.awards.${index}.summary`"
            class="summary"
            v-text="award.summary"
            @click="
              evt =>
                openRephrasePopup(`resume.awards.${index}.summary`, evt.target)
            "
          ></span>
        </section>
      </template>
    </section>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { Resume } from '@/types/resume/v1'
import DateDisplay from './support/DateDisplay.vue'
import { useStructuredResumeStore } from '@/store/pinia/structuredResume'
import { usePowerEditStore } from '@/store/pinia/powerEdit'
import SectionActions from './SectionActions.vue'
import ItemActions from './ItemActions.vue'

export default defineComponent({
  name: 'Awards',
  components: { DateDisplay, SectionActions, ItemActions },
  props: {
    awards: {
      type: Object as PropType<Resume.Award[]>,
      required: false,
    },
  },
  setup() {
    const store = useStructuredResumeStore()
    const powerEditStore = usePowerEditStore()
    const { closePopup, openRephrasePopup } = powerEditStore

    return { isPowerEdit: store.isPowerEdit, closePopup, openRephrasePopup }
  },
})
</script>

<style lang="postcss" scoped>
.awards {
  @apply text-base-em pt-6-em;
  h3 {
    @apply leading-none text-xl-em flex items-center;
    .actions {
      @apply hidden;
    }
    &:hover {
      .actions {
        @apply flex;
      }
    }
  }
  .list {
    .award {
      @apply pt-4-em relative;
      .itemActions {
        @apply hidden;
      }
      &:hover {
        .itemActions {
          @apply flex;
        }
      }
      .details {
        @apply flex flex-row justify-between items-start flex-nowrap space-x-2-em;
        .title {
          @apply font-semibold;
        }
        .date {
          @apply text-sm-em whitespace-nowrap;
        }
      }
      .awarder {
        @apply text-sm-em italic mb-2-em flex flex-row justify-between items-center flex-wrap;
      }
      .summary {
        @apply text-sm-em whitespace-pre-wrap inline-block leading-[inherit];
      }
    }
  }
}
</style>
